import React from 'react';
import styled from 'styled-components';

import InputSelect from './InputSelect';

interface props {
  name: string;
  options: options[];
  defaultValue?: boolean;
}

interface options {
  value: string;
  label: string;
  disabled?: boolean;
  selected?: boolean;
}

const Component = React.forwardRef((props, ref) => {
  return (
    <InputSelect {...props} ref={ref}>
      {
        props.options.map((option:options, index:number) => (
          <option value={option.value} key={index} disabled={option.disabled} selected={option.selected}>{option.label}</option>
        ))
      }
    </InputSelect>
  );
});

export default Component;
